import DOMPurify from "dompurify";
import { Styles } from "./Style";
import { forwardRef } from "react";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  html: string;
  style?: React.CSSProperties;
  className?: string;
  isOverlay?: boolean;
}
const SafeHtml = (
  { html, style, className, isOverlay, ...restProps }: IProps,
  ref: any,
) => {
  if (!html) return <div ref={ref} {...restProps} />;
  const cleanHtml = DOMPurify.sanitize(html);
  return (
    <Styles {...restProps}>
      <div
        ref={ref}
        className={className || ""}
        style={style}
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
      {isOverlay && <div className="overlay"></div>}
    </Styles>
  );
};

export default forwardRef(SafeHtml);
